import { API_URL } from 'common-ui-components/components/utils/Config';

export const links={
    "zecurit": "https://zecurit.com/",
    
    //user profile
    "help": "https://zecurit.com/help/",
    "faq":"https://zecurit.com/help/faq/",
    "blog":"https://zecurit.com/blog",
    "payments":"https://apppre.zecurit.com/app/settings/account/subscription",
    "support":"https://zecurit.com/contact/",

    //home-resources
    "userGuide":"https://zecurit.com/help/asset-management/getting-started/",
    "knowledgeBase":"https://zecurit.com/resources",
    "sysReq":"https://zecurit.com/help/asset-management/getting-started/system-requirements/",
    "demoReq":"https://zecurit.com/demo",
    "contact":"https://zecurit.com/contact/",

    //inventory
    "alerts":"https://zecurit.com/help/asset-management/asset-management/alerts-compliance/alert-policy/",
    "geolocation":"https://zecurit.com/help/asset-management/asset-management/inventory-management/geo-tracking/",
    "InventoryScan":"https://zecurit.com/help/asset-management/asset-management/inventory-management/inventory-scan/",

    //Secure
    "testAndApprove":"https://zecurit.com/help/endpoint-management/patch-management/test-and-approve/",
    "apd":"https://zecurit.com/help/endpoint-management/patch-management/automate-patch-deployment/",
    
    //settings 
    "usersAndRoles":"https://zecurit.com/help/asset-management/settings/access-permissions/user-role-management/",
    "customRoles":"https://zecurit.com/help/asset-management/settings/access-permissions/custom-role-permissions/",
    "groups":"https://zecurit.com/help/asset-management/settings/organization-settings/device-groups/",
    "rebranding":"https://zecurit.com/help/asset-management/settings/organization-settings/rebranding/",

    //security settings
    "twoFA":"https://zecurit.com/help/asset-management/settings/security-compliance/two-factor-authentication/",
    "ipRestriction":"https://zecurit.com/help/asset-management/settings/security-compliance/ip-restriction/",
    "sessionSettings":"https://zecurit.com/help/asset-management/settings/security-compliance/session-settings/",
    "agentProtection":"https://zecurit.com/help/asset-management/settings/security-compliance/agent-protection/",
    "dataCleanup":"https://zecurit.com/help/asset-management/settings/security-compliance/data-cleanup/",

    //enrollment
    "microsoftAzure":"https://zecurit.com/help/asset-management/device-enrollment/silent-and-bulk-enrollment/enrollment-via-microsoft-azure/",
    "activeDirectory":"https://zecurit.com/help/asset-management/device-enrollment/silent-and-bulk-enrollment/enrollment-via-active-directory-gpo/",
    "microsoftIntune":"https://zecurit.com/help/asset-management/device-enrollment/silent-and-bulk-enrollment/enrollment-via-microsoft-intune/",
    "sccm":"https://zecurit.com/help/asset-management/device-enrollment/silent-and-bulk-enrollment/enrollment-via-sccm/",

    //cloud deployment api links
    "azureDeployment" : API_URL + "/devices/agent/WINDOWS_MAIN/AZURE/download",
    "gpoDeployment" : API_URL + "/devices/agent/WINDOWS_MAIN/GPO/download",
    "intuneDeployment" : API_URL + "/devices/agent/WINDOWS_MAIN/INTUNE/download",
    "sccmDeployment" : API_URL + "/devices/agent/WINDOWS_MAIN/SCCM/download",
    "azureAutomationDeployment" : API_URL + "/devices/agent/WINDOWS_MAIN/AZURE_AUTOMATION/download",
}